import { Space, Table } from "antd";

import { GrView } from "react-icons/gr";
import { useNavigate } from "react-router-dom";

function TaskDataTable(props: any) {
  const navigate = useNavigate();
  const columns = [
    {
      dataIndex: "name",
      title: "Name",
    },
    {
      dataIndex: "username",
      title: "username",
    },
    {
      dataIndex: "password",
      title: "password",
    },
    {
      dataIndex: "companyName",
      title: "companyName",
    },
    {
      dataIndex: "address",
      title: "address",
    },
    {
      dataIndex: "client_phone",
      title: "client_phone",
    },

    {
      title: "Action",
      key: "id",
      render: (_: any, record: any) => (
        <Space size="middle">
          <GrView
            color="blue"
            size={20}
            onClick={() => navigate(`/HR/Client/viewclient/${record?.id}`)}
          />
        </Space>
      ),
    },
  ];

  return (
    <div>
      <Table
        columns={columns}
        dataSource={Array.isArray(props?.dataSource) ? props?.dataSource : []}
        pagination={props?.pagination}
      />
    </div>
  );
}

export default TaskDataTable;
